/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import { GLOBAL_PARAMS } from "src/constants/params";
import { formatPathByLogicalGroupChannel, filterParams } from "src/utils/url";
import SubMenuDrawer from "./SubMenuDrawer";
import { HeaderMenu } from "../../IHeader";
import {
  MainMenuBody,
  MainMenuContainer,
  MainMenuLi,
  MainMenuLink,
  MainMenuText,
  MainMenuUl,
  UpDownIcon,
} from "./MainMenu.style";

type CustomMainMenuProps = {
  subMenuVisible: boolean;
  setSubMenuVisible: any;
  menus?: HeaderMenu;
};

const MainMenu = ({
  subMenuVisible,
  setSubMenuVisible,
  menus,
}: CustomMainMenuProps): JSX.Element => {
  const { t, i18n } = useTranslation("layout");
  const router = useRouter();

  const channelPath =
    typeof router.query.channelPath === "object"
      ? router.query.channelPath?.[0]
      : router.query.channelPath;

  const triggerSubMenu = () => setSubMenuVisible(!subMenuVisible);
  const closeSubMenu = () => setSubMenuVisible(false);

  const handleGoToAffiliatePage = () => {
    router.push({
      pathname: formatPathByLogicalGroupChannel(`/${channelPath}/affiliate`),
      query: filterParams(router.query, GLOBAL_PARAMS),
    });
  };

  return (
    <>
      <MainMenuContainer>
        <MainMenuUl>
          <MainMenuLi>
            <MainMenuLink onClick={triggerSubMenu}>
              <MainMenuBody level={5}>
                {t("header.buyOnline")}
                <UpDownIcon>
                  {subMenuVisible ? <UpOutlined /> : <DownOutlined />}
                </UpDownIcon>
              </MainMenuBody>
            </MainMenuLink>
          </MainMenuLi>
          <MainMenuLi>
            <MainMenuText onClick={handleGoToAffiliatePage}>
              <MainMenuBody level={5}>
                {menus?.sundayAffiliate?.label || t("header.sundayAffiliate")}
              </MainMenuBody>
            </MainMenuText>
          </MainMenuLi>
          <MainMenuLi>
            <MainMenuLink
              href={
                menus?.faq?.href ||
                `https://easysunday.com/${i18n.language}/faq`
              }
            >
              <MainMenuBody level={5}>
                {menus?.faq?.label || t("header.faq")}
              </MainMenuBody>
            </MainMenuLink>
          </MainMenuLi>
          <MainMenuLi>
            <MainMenuLink
              href={menus?.blog?.href || `https://easysunday.com/blog`}
            >
              <MainMenuBody level={5}>
                {menus?.blog?.label || t("header.blog")}
              </MainMenuBody>
            </MainMenuLink>
          </MainMenuLi>
          <MainMenuLi>
            <MainMenuLink
              href={
                menus?.contactUs?.href ||
                `https://easysunday.com/${i18n.language}/contact-us`
              }
            >
              <MainMenuBody level={5}>
                {menus?.contactUs?.label || t("header.contactus")}
              </MainMenuBody>
            </MainMenuLink>
          </MainMenuLi>
          <MainMenuLi>
            <MainMenuLink
              href={menus?.aboutUs?.href || `https://about.easysunday.com`}
            >
              <MainMenuBody level={5}>
                {menus?.aboutUs?.label || t("header.about")}
              </MainMenuBody>
            </MainMenuLink>
          </MainMenuLi>
        </MainMenuUl>
      </MainMenuContainer>
      <SubMenuDrawer visible={subMenuVisible} onClose={closeSubMenu} />
    </>
  );
};

export default MainMenu;
